export const CD_PREFIX = 'calendar-dashboard';
export const CD_FULL_DAY_HEIGHT = 116;
export const CD_TIME_LINE_HEIGHT = 18;
